import React from 'react';
import { Controller } from 'react-hook-form';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePickeDesktop, HelperText } from 'components/Ui/styled';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

export const FormInputDate = (props) => {
  const {
    name,
    control,
    label,
    register,
    errors,
    helperText,
    minDate,
    maxDate,
    readOnly,
    value,
  } = props;

  const today = new Date();
  const defaultMinDate = new Date(today.getFullYear() - 10, 0, 1);
  const defaultMaxDate = new Date(today.getFullYear() + 10, 11, 31);

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value: fieldValue } }) => (
          <DatePickeDesktop
            label={label}
            inputFormat="MM/dd/yyyy"
            minDate={minDate || defaultMinDate}
            maxDate={maxDate || defaultMaxDate}
            value={
              fieldValue ? new Date(fieldValue) : value ? new Date(value) : null
            }
            inputProps={{ readOnly: true }}
            onChange={onChange}
            readOnly={readOnly}
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                error={!!errors}
                helperText={helperText}
              />
            )}
          />
        )}
      />
      <HelperText>{helperText}</HelperText>
    </LocalizationProvider>
  );
};
